/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CatalogItemDetail } from '../models/CatalogItemDetail';
import type { CatalogItemListResponse } from '../models/CatalogItemListResponse';
import type { CategoryListResponse } from '../models/CategoryListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CatalogService {
    /**
     * List public catalog categories
     * @returns CategoryListResponse Public category list
     * @throws ApiError
     */
    public static getApiV1CatalogCategories(): CancelablePromise<CategoryListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/catalog/categories',
        });
    }
    /**
     * List public catalog items
     * @returns CatalogItemListResponse Public catalog page
     * @throws ApiError
     */
    public static getApiV1CatalogItems({
        search,
        categoryId,
        limit = 20,
        cursor,
    }: {
        search?: string,
        categoryId?: string,
        limit?: number,
        cursor?: string,
    }): CancelablePromise<CatalogItemListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/catalog/items',
            query: {
                'search': search,
                'category_id': categoryId,
                'limit': limit,
                'cursor': cursor,
            },
        });
    }
    /**
     * Get public catalog item detail
     * @returns CatalogItemDetail Catalog item detail
     * @throws ApiError
     */
    public static getApiV1CatalogItems1({
        itemId,
    }: {
        itemId: string,
    }): CancelablePromise<CatalogItemDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/catalog/items/{itemId}',
            path: {
                'itemId': itemId,
            },
            errors: {
                404: `Item not found`,
            },
        });
    }
}
